export function useDelayedRenderer(onRender, delay = 20) {
  let queue = [];
  let rendering = false;
  let timeoutId = null;

  function processQueue() {
    if (!queue.length) {
      rendering = false;
      timeoutId = null;
      return;
    }

    rendering = true;

    const chunk = queue.shift();
    if (chunk !== undefined) {
      onRender(chunk);
    }

    timeoutId = setTimeout(processQueue, delay);
  }

  function pushChunk(chunk) {
    queue.push(chunk);

    if (!rendering) {
      processQueue();
    }
  }

  function flush() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    while (queue.length) {
      const chunk = queue.shift();
      if (chunk !== undefined) {
        onRender(chunk);
      }
    }

    rendering = false;
  }

  function stop({ flush: shouldFlush = false } = {}) {
    if (shouldFlush) {
      flush();
      return;
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    queue = [];
    rendering = false;
  }

  return {
    pushChunk,
    flush,
    stop,
  };
}
